import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { ApiService } from "../http/api.service";
import { catchError, mergeMap } from "rxjs/operators";
import { of, throwError } from "rxjs";

export const availabilityGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const apiService: ApiService = inject(ApiService);
  const router: Router = inject(Router);

  if (route.queryParams["invite_code"]) {
    return of(true);
  }

  return apiService.checkAvailability().pipe(
    mergeMap((r) => (r.available ? of(true) : throwError(r.reason))),
    catchError((err) => {
      return router.navigate(["/availability"], {
        queryParams: {
          reason: err,
          r: route.queryParams["r"],
        },
      });
    })
  );
};
